import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import EventDetails from './components/EventDetails';
import RSVP from './components/RSVP';
import Accommodation from './components/Accommodation';
import Location from './components/Location';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import UKFlag from './components/UKFlag';
import SpainFlag from './components/SpainFlag';
import PointsOfInterest from './components/PointsOfInterest';
import Activities from './components/Activities';
import Gift from './components/Gift';
import { useIntersectionObserver } from './hooks/useIntersectionObserver';
import { useOnClickOutside } from './hooks/useOnClickOutside';

function App() {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeId, setActiveId] = useState('');
  const navRef = useRef();

  useIntersectionObserver(setActiveId);
  useOnClickOutside(navRef, () => setMenuOpen(false));

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [menuOpen]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <div className="top-bar">
        <Header />
        <nav ref={navRef}>
          <div className="hamburger-menu" onClick={toggleMenu}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
          <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
            <a href="#introduction" onClick={toggleMenu} className={activeId === 'introduction' ? 'active' : ''}>{t('nav_home')}</a>
            <a href="#event-details" onClick={toggleMenu} className={activeId === 'event-details' ? 'active' : ''}>{t('nav_event_details')}</a>
            <a href="#rsvp" onClick={toggleMenu} className={activeId === 'rsvp' ? 'active' : ''}>{t('nav_rsvp')}</a>
            <a href="#accommodation" onClick={toggleMenu} className={activeId === 'accommodation' ? 'active' : ''}>{t('nav_accommodation')}</a>
            <a href="#location" onClick={toggleMenu} className={activeId === 'location' ? 'active' : ''}>{t('nav_location')}</a>
            <a href="#points-of-interest" onClick={toggleMenu} className={activeId === 'points-of-interest' ? 'active' : ''}>{t('points_of_interest')}</a>
            <a href="#activities" onClick={toggleMenu} className={activeId === 'activities' ? 'active' : ''}>{t('activities')}</a>
            <a href="#photo-gallery" onClick={toggleMenu} className={activeId === 'photo-gallery' ? 'active' : ''}>{t('nav_gallery')}</a>
            <a href="#gift" onClick={toggleMenu} className={activeId === 'gift' ? 'active' : ''}>{t('nav_gift')}</a>
          </div>
        </nav>
      </div>
      <main>
        <Home />
        <EventDetails />
        <RSVP />
        <Accommodation />
        <Location />
        <PointsOfInterest />
        <Activities />
        <Gallery />
        <Gift />
      </main>
      <Footer />
    </>
  );
}

export default App;
